import { Component, OnInit, ViewContainerRef, viewChild } from '@angular/core';
import { Modal } from '../../modal';
import { showHide } from '../../modal-animations';

@Component({
    selector: 'app-modal-template-no-close',
    templateUrl: './modal-template-no-close.component.html',
    styleUrls: ['./modal-template-no-close.component.scss'],
    animations: [showHide],
    standalone: true
})
export class ModalTemplateNoCloseComponent extends Modal implements OnInit {

  readonly contentRef = viewChild('content', { read: ViewContainerRef });

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
